/**
 * Locale → its dictionary chunk. GENERATED by `tooling/theme-i18n/src/gen-admin.ts`.
 *
 * A MAP of arrow functions rather than eager imports, and each `import()` written out in full: both
 * details matter to the bundler. A literal specifier is what lets it content-hash one chunk per
 * language and load exactly one; `import(\`./\${locale}\`)` would defeat the static analysis and
 * ship all 7 as a single file.
 *
 * These used to be EAGER, on the reasoning that "the editor loads ONE locale per page load, resolved
 * at module scope, and has no reload to hide a dynamic import behind". The first half was right and
 * the second was the mistake: 7 dictionaries at ~240 kB of source each sat in the entry chunk so
 * that one of them could be read. `main.tsx` awaits the chunk BEFORE the first render, which is the
 * same guarantee the eager imports gave, at one 7th of the bytes.
 *
 * There is no English file — English is the literal in the schema and `translateFields` falls back to
 * it, so a reader we have no dictionary for is served by the code itself.
 *
 * Generated from the files that EXIST in this directory, so it cannot claim a language we do not have.
 */
import type { BuilderDictionary } from './locales';

export const LOADERS: Readonly<Record<string, () => Promise<BuilderDictionary>>> = {
  fr: () => import('./fr').then((m) => m.fr),
  ar: () => import('./ar').then((m) => m.ar),
  de: () => import('./de').then((m) => m.de),
  es: () => import('./es').then((m) => m.es),
  it: () => import('./it').then((m) => m.it),
  pl: () => import('./pl').then((m) => m.pl),
  pt: () => import('./pt').then((m) => m.pt),
};
